import CCMRBulkEntry from './CCMRBulkEntry.container';

export default CCMRBulkEntry;
